import { twMerge } from 'tailwind-merge';

type ClassValue = string | false | null | undefined;

/** Join class names (dropping falsy values) and resolve Tailwind conflicts: later classes win. */
export function cn(...classes: ClassValue[]): string {
  return twMerge(classes.filter(Boolean).join(' '));
}
